// src/screens/EnrollmentOverview.js
import React, { useContext } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { MainContext } from "../App";
import { HeaderCard, useEnrollmentLeaderboardLive } from "../components/CollectionEnrollmentPage";

const EnrollmentOverview = () => {
  const { Theme, deviceType } = useContext(MainContext);

  // grab a generous limit; these are already sorted by totalPoints desc
  const { loading, items: collections } = useEnrollmentLeaderboardLive({
    limitCount: 200,
  });

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        bgcolor: "#090318",
        display: "flex",
        justifyContent: "center",
        px: deviceType === "desktop" ? 4 : 1,
        py: deviceType === "desktop" ? 6 : 4,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1200,
          mx: "auto",
        }}
      >
        {/* PAGE HEADER */}
        <Box
          sx={{
            mb: 3,
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: 900,
              color: Theme.palette.text.main,
              fontSize: deviceType === "desktop" ? "2.75rem" : "2.0rem",
              WebkitTextStroke: "1px #230a67",
              textShadow:
                "-2px -2px 0 #230a67, 2px -2px 0 #230a67, -2px 2px 0 #230a67, 2px 2px 0 #230a67",
            }}
          >
            Season 2 Enrolling Collections
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#c9b7ff",
              maxWidth: 720,
              opacity: 0.9,
            }}
          >
            These are all NFT collections currently enrolling into InfiNFT Royale.
            Support your favorites, help them climb the leaderboard, and get
            their IP in game.
          </Typography>
        </Box>

        {/* CONTENT */}
        {loading ? (
          <Grid container spacing={3}>
            {Array.from({ length: 6 }).map((_, idx) => (
              <Grid item xs={12} md={6} key={idx}>
                <Box
                  sx={{
                    height: 220,
                    borderRadius: 2,
                    bgcolor: "#231543",
                    border: (t) => `1px solid ${t.palette.tirciary.light}`,
                  }}
                />
              </Grid>
            ))}
          </Grid>
        ) : collections.length === 0 ? (
          <Typography
            variant="body1"
            sx={{ color: "#c9b7ff", opacity: 0.9, mt: 2 }}
          >
            No collections are currently enrolled. Check back soon or hop into
            Discord to learn how to get your collection in for the next wave.
          </Typography>
        ) : (
          <Grid container spacing={3}>
            {collections.map((col, idx) => (
              <Grid item xs={12} md={6} key={col.id}>
                {/* Optional: tiny rank tag above each card */}
                <Box sx={{ mb: 1 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#ffd24d",
                      fontWeight: 700,
                      letterSpacing: 0.5,
                      textTransform: "uppercase",
                    }}
                  >
                    #{idx + 1} by Points
                  </Typography>
                </Box>
                <HeaderCard collection={col} />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default EnrollmentOverview;
